import { Select } from '@mantine/core';
import { useListSitesByUser } from 'api/resource';
import { Site } from 'interfaces';
import React, { useEffect } from 'react';
import { useCurrentUserStore } from 'store/UserStore';

interface SiteSelectorProps {
  setSites: React.Dispatch<React.SetStateAction<Site[]>>;
  setFetchedSites: React.Dispatch<React.SetStateAction<boolean>>;
  selectedSiteID: string;
  handleSiteChange: (value: string | null) => void;
}

export const SiteSelector: React.FC<SiteSelectorProps> = ({
  setSites,
  setFetchedSites,
  handleSiteChange,
  selectedSiteID,
}) => {
  const { id: userID } = useCurrentUserStore();
  const { data: sites = [], isFetched: fetchedSites } = useListSitesByUser({
    userID,
  });

  useEffect(() => {
    if (sites.length) {
      setSites(sites);
      setFetchedSites(fetchedSites);
    }
  }, [sites, fetchedSites]);

  return (
    <>
      {(userID || sites.length === 1) && (
        <Select
          data={sites.map((site) => ({
            value: site.id,
            label: site.name,
          }))}
          value={selectedSiteID || sites[0]?.id}
          placeholder="Select Site"
          data-testid="siteMultiSelect"
          disabled={!fetchedSites}
          onChange={handleSiteChange}
          miw={'20%'}
          maw={'10%'}
        />
      )}
    </>
  );
};
